import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100%;
  transition: transform 0.2s;
  margin: 10px 0 31px;
  max-width: 27vw;

  @media (max-width: 1600px) {
    max-width: 27vw;
  }

  @media (max-width: 1280px) {
    max-width: 35vw;
  }

  @media (max-width: 1024px) {
    max-width: 43vw;
  }

  @media (max-width: 820px) {
    max-width: 50vw;
    padding-left: 10px;
  }

  @media (max-width: 540px) {
    max-width: 83vw;
  }

  @media (max-width: 280px) {
    padding-left: 0px;
    max-width: 83vw;
  }
`;

export const Content = styled.div`
  box-shadow: 2px 2px 6px 2px rgba(0, 0, 0, 0.2);
  display: flex;
  padding: 14px 8px 14px 0;
  width: 100%;
  height: 130px;
  background: ${({ theme }) => theme.backgroundCard};
  display: flex;
  align-items: center;
  max-width: 100%;

  > span {
    min-width: 120px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      min-height: 90px;
      width: 90px;
    }
  }

  div {
    height: 100%;

    span {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;

      h1 {
        line-height: 30px;
        font-size: 1.5rem;
        font-weight: 600;
        margin: 0;
        color: ${({ theme }) => theme.text};
      }

      h2 {
        line-height: 25px;
        margin: 0;
        font-weight: 500;
        font-size: 1.25rem;
        color: ${({ theme }) => theme.text};

        &:nth-child(2) {
          margin-bottom: 10px;
        }
      }
    }
  }

  > span {
    width: 80px;
    img {
      height: 50px;
    }
  }

  @media (max-width: 380px) {
    > span {
      min-width: 90px;
      img {
        min-height: 60px;
        width: 60px;
      }
    }
  }

  @media (max-width: 310px) {
    div {
      span {
        h1 {
          font-size: 1.5rem;
        }
        h2 {
          font-size: 1rem;
        }
      }
    }
  }

  @media (max-width: 280px) {
    height: 110px;
    div {
      span {
        h1 {
          font-size: 1.15rem;
        }
        h2 {
          font-size: 1rem;
        }
      }
    }
  }
`;
